import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const LivePlayer = ({ streamUrl }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!streamUrl || !videoRef.current) return;

    // Add timestamp to bypass cache for MediaTailor live manifest
    const liveStreamUrl = `${streamUrl}${streamUrl.includes('?') ? '&' : '?'}t=${Date.now()}`;

    let hls;

    if (Hls.isSupported()) {
      hls = new Hls({
        lowLatencyMode: false, // disable to allow more buffering
        maxLiveSyncPlaybackRate: 1.0,
        liveSyncDuration: 10, // target live sync buffer (in seconds)
        liveMaxLatencyDuration: 15, // max buffer latency
        maxBufferLength: 30,
        maxMaxBufferLength: 60,
        backBufferLength: 30,
      });

      hls.attachMedia(videoRef.current);
      hls.loadSource(liveStreamUrl);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoRef.current.play().catch((err) => console.warn('Autoplay blocked:', err));
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js error:", data);
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              hls.recoverMediaError();
              break;
            default:
              hls.destroy();
              break;
          }
        }
      });
    } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
      videoRef.current.src = liveStreamUrl;
      videoRef.current.play().catch((err) => console.warn('Autoplay blocked:', err));
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [streamUrl]);

  return (
    <video
      ref={videoRef}
      controls
      autoPlay
      muted
      playsInline
      preload="auto"
      style={{ width: '100%', height: '100%' }}
    />
  );
};

export default LivePlayer;
